import React from "react";
import { Navigate } from "react-router-dom";

interface Props {
  component: React.ComponentType;
}

const PrivateRoute: React.FC<Props> = ({ component: RouteComponent }) => {
  const localJwtToken = sessionStorage.getItem("DsbaAdminToken");
  //make api cal usinfg this token (Get my info) and update user info in redux
  //api call in all pages?
  console.log("localJwtToken:", localJwtToken);
  const isAuthenticated = localJwtToken ? true : false; //uncomment later
  // const isAuthenticated = true;
  console.log(" isAuthenticated", isAuthenticated);
  if (isAuthenticated) {
    return <RouteComponent />;
  }
  const path = "/sign-in?path=" + window.location.pathname;
  return <Navigate to={path} />;
};

export default PrivateRoute;
